// SIDEBAR NAV (GSAP)
//
//
//
//
//
//
export function initSidebarNav() {

// search sidebar nav
const $siteNavSidebar = document.querySelector('.meta-nav-sidebar');
// only activate if sidebar nav is found
if ($siteNavSidebar) {

  let vdrops = document.querySelectorAll(".vdrop");

  // Function to update parent dropdown height when nested dropdowns change
  function updateParentHeight(vdrop) {
    // Find all parent vdrops that contain this one
    let parent = vdrop.parentElement.closest('.vdrop');
    while (parent) {
      const parentMenu = parent.querySelector('.vdrop-list');
      if (parentMenu && parentMenu.style.height !== '0px' && parentMenu.style.height !== '') {
        // Parent is open, recalculate its height
        // Temporarily set height to auto to get accurate scrollHeight that accounts for collapsed nested menus
        const currentHeight = parentMenu.style.height;
        parentMenu.style.height = 'auto';
        const newHeight = parentMenu.scrollHeight;
        parentMenu.style.height = currentHeight;
        
        gsap.to(parentMenu, {
          height: newHeight,
          duration: 0.2,
          ease: 'ease.out'
        });
      }
      parent = parent.parentElement.closest('.vdrop');
    }
  }

  vdrops.forEach(vdrop => {
    const toggle = vdrop.querySelector('.vdrop-btn');
    const menu = vdrop.querySelector('.vdrop-list');
    const menuItems = menu.querySelectorAll('.navlink-sidebar');
    
    // Check if this is a nested dropdown: nested dropdowns have a link inside vdrop-btn
    const hasLink = toggle?.querySelector('a');
    const nestedButton = hasLink ? toggle?.querySelector('button[aria-haspopup="true"]') : null;
    
    // For nested dropdowns, the button itself is the icon; for parent dropdowns, it's a separate .metadrop-icon div
    const dropicon = nestedButton || vdrop.querySelector('.metadrop-icon');
    // Define clickTarget here so it's available in openMenu/closeMenu
    const clickTarget = nestedButton || toggle;

    // Don't pre-calculate - we'll calculate dynamically
    menu.style.height = '0px'; // Initial height
    menu.style.overflow = 'hidden';
    menu.style.opacity = '0'; // Start hidden
    if (dropicon && !nestedButton) {
      // Only set transition for separate icon elements, not for button icons
      dropicon.style.transition = 'transform 0.3s ease-out';
    }

    // Function to get current menu height (dynamic calculation)
    function getMenuHeight() {
      // Temporarily set height to auto to get accurate scrollHeight
      const currentHeight = menu.style.height;
      menu.style.height = 'auto';
      const height = menu.scrollHeight;
      menu.style.height = currentHeight;
      return height;
    }

    // Function to open the menu using GSAP
    function openMenu() {
      const menuHeight = getMenuHeight();
      // Get the gap from CSS variable
      const gapValue = getComputedStyle(document.documentElement).getPropertyValue('--misc--gap-nav-sidebar').trim() || '0.5rem';
      gsap.to(menu, {
        height: menuHeight,
        opacity: 1,
        marginTop: gapValue,
        duration: 0.3,
        ease: 'ease.out',
        onComplete: () => {
          // After opening, update parent heights if this is a nested dropdown
          updateParentHeight(vdrop);
        }
      });
      if (clickTarget) {
        clickTarget.setAttribute('aria-expanded', 'true');
      }
      menu.setAttribute('aria-hidden', 'false');
      menu.style.display = 'flex'; // Ensure the menu remains in the flow
      menuItems[0]?.focus(); // Focus the first item after opening
      if (dropicon) {
        // For nested buttons, rotate the SVG inside; for separate icons, rotate the icon
        if (nestedButton) {
          const svg = dropicon.querySelector('svg');
          if (svg) {
            gsap.to(svg, { rotation: 180, duration: 0.3, ease: 'ease.out' });
          }
        } else {
          gsap.to(dropicon, { rotation: 180, duration: 0.3, ease: 'ease.out' });
        }
      }
    }

    // Function to close the menu using GSAP
    function closeMenu() {
      gsap.to(menu, {
        height: 0,
        opacity: 0,
        marginTop: 0,
        duration: 0.3,
        ease: 'ease.out',
        onComplete: () => {
          // After closing, update parent heights if this is a nested dropdown
          updateParentHeight(vdrop);
        }
      });
      if (clickTarget) {
        clickTarget.setAttribute('aria-expanded', 'false');
      }
      menu.setAttribute('aria-hidden', 'true');
      if (dropicon) {
        // For nested buttons, rotate the SVG inside; for separate icons, rotate the icon
        if (nestedButton) {
          const svg = dropicon.querySelector('svg');
          if (svg) {
            gsap.to(svg, { rotation: 0, duration: 0.3, ease: 'ease.out' });
          }
        } else {
          gsap.to(dropicon, { rotation: 0, duration: 0.3, ease: 'ease.out' });
        }
      }
    }

    // Toggle menu on button click - handle both button and nested button cases
    if (toggle) {
      clickTarget.addEventListener('click', (e) => {
        // Only handle clicks on the button itself, not on links inside
        if (nestedButton && e.target.closest('a')) {
          return; // Let the link navigate normally
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        if (menu.style.height === '0px' || menu.style.height === '') {
          openMenu();
        } else {
          closeMenu();
          clickTarget.focus(); // Return focus to toggle after closing
        }
      });

      // Keyboard navigation for toggle
      clickTarget.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (menu.style.height === '0px' || menu.style.height === '') {
            openMenu();
          } else {
            closeMenu();
            clickTarget.focus();
          }
        }
      });
    }

    // Keyboard navigation within the menu
    menu.addEventListener('keydown', (e) => {
      const index = Array.from(menuItems).indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = (index + 1) % menuItems.length;
        menuItems[nextIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = (index - 1 + menuItems.length) % menuItems.length;
        menuItems[prevIndex].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
        toggle.focus(); // Return focus to toggle on escape
      }
    });

    // Close the menu when clicking outside
    document.addEventListener('click', (event) => {
      if (!vdrop.contains(event.target)) {
        closeMenu();
      }
    });
  });

  //////////// MOBILE SIDEBAR (Updated)

// Only initialize mobile sidebar if hamburger element exists
const hamburger = document.querySelector(".meta-nav-sidebar-hamburger");
if (hamburger) {
  const sidebar = document.querySelector(".meta-nav-sidebar");
  let isSidebarOpen = false;

  // Function to open sidebar using GSAP
  const openSidebar = () => {
    isSidebarOpen = true;
    // Flip to visible BEFORE animating so GSAP tweens a rendered element.
    // Keeping it hidden while closed lets iOS Safari's dynamic viewport stay active
    // (body/main backgrounds can bleed behind the translucent bottom tab bar).
    sidebar.style.visibility = 'visible';
    gsap.to(sidebar, {
      x: '0%', // Slide the sidebar in
      duration: 0.3,
      ease: 'ease.out'
    });
    hamburger.classList.add("active");
    hamburger.setAttribute('aria-expanded', 'true');
    lockScroll();
    
    // Pass the sidebar element directly to prevent scroll outside
    preventScrollOutside(".meta-nav-sidebar");
  };

  // Function to close sidebar using GSAP
  const closeSidebar = () => {
    isSidebarOpen = false;
    gsap.to(sidebar, {
      x: '-110%', // Slide the sidebar out
      duration: 0.3,
      ease: 'ease.out',
      onComplete: () => {
        // After the slide-out finishes, hide the element so iOS Safari drops its
        // viewport-pinning behaviour (position:fixed + height:100svh) and the
        // body/main backgrounds bleed under the translucent bottom tab bar again.
        // Only do this on mobile; on desktop the sidebar must remain visible.
        if (window.innerWidth < 992) {
          sidebar.style.visibility = 'hidden';
        }
      }
    });
    hamburger.classList.remove("active");
    hamburger.setAttribute('aria-expanded', 'false');
    unlockScroll();
    removeScrollPrevention();
    // Ensure scroll is unlocked and scroll prevention is removed
    
  };

  const handleResize = () => {
    if (window.innerWidth >= 991) {
      // Desktop breakpoint: ensure sidebar is visible
      gsap.set(sidebar, { x: '0%' });
      sidebar.style.visibility = 'visible';
      if (isSidebarOpen) {
        isSidebarOpen = false; // Reset state
        unlockScroll();        // Unlock only if it was previously locked
        removeScrollPrevention();
      }
    } else if (!isSidebarOpen) {
      // Mobile breakpoint: ensure sidebar is hidden (also removes iOS Safari
      // viewport pin so body/main can bleed behind the bottom tab bar).
      gsap.set(sidebar, { x: '-110%' });
      sidebar.style.visibility = 'hidden';
    }
  };

  // Toggle sidebar on hamburger click
  hamburger.addEventListener("click", () => {
    if (isSidebarOpen) {
      closeSidebar();
    } else {
      openSidebar();
    }
  });

  // Close sidebar when clicking outside
  document.addEventListener("click", (event) => {
    const isClickInsideSidebar = sidebar.contains(event.target);
    const isClickOnHamburger = hamburger.contains(event.target);
    if (isSidebarOpen && !isClickInsideSidebar && !isClickOnHamburger) {
      closeSidebar();
    }
  });

  // Listen for resize events
  window.addEventListener("resize", handleResize);

  // Call handleResize on page load to ensure correct state
  handleResize();
}

} // end only activate if sidebar nav is found

} // end module
